const OurServices = () => {
  return (
    <div className="py-16 max-w-7xl mx-auto">
      <h2 className="md:text-5xl text-4xl font-semibold tracking-tight text-center text-[#0a1b48]">
        Services
      </h2>
      <div className="container m-auto px-6 text-gray-500 md:px-12 xl:px-0 mt-10">
        <div className="mx-auto grid gap-6 md:w-3/4 lg:w-full lg:grid-cols-3">
          <div className="bg-white rounded-2xl shadow-xl px-8 py-12 sm:px-12 lg:px-8 flex flex-col">
            <div className="mb-12 space-y-4 flex-grow">
              <h3 className="text-2xl font-semibold text-[#0a1b96]">
                Installation
              </h3>
              <p className="mb-6">
                We provide elevator installation services in Lebanon, the Middle
                East, and Africa, covering all aspects of electrical work,
                including door installation, wiring, and thorough testing to
                ensure optimal functionality
              </p>
            </div>
            <img
              src="https://www.dayelevator.com/wp-content/uploads/2020/09/construction-time.jpg"
              className="w-full h-40 object-cover "
              alt="illustration"
              loading="lazy"
            />
          </div>
          <div className="bg-white rounded-2xl shadow-xl px-8 py-12 sm:px-12 lg:px-8 flex flex-col">
            <div className="mb-12 space-y-4 flex-grow">
              <h3 className="text-2xl font-semibold text-[#0a1b96]">
                Maintenance
              </h3>
              <p className="mb-6">
                We offer full elevator maintenance services, from passenger
                lifts to dumbwaiters, across various brands. Count on us for
                upkeep, repairs, and safety checks
              </p>
            </div>
            <img
              src="https://www.adexcel-group.com/sites/default/files/styles/component_text_image_large/public/2023-07/Maintenance-reparation-informatique-AdExcel.jpg?h=07845c6b&itok=G36LbC-c"
              className="w-full h-40 object-cover "
              alt="illustration"
              loading="lazy"
            />
          </div>
          <div className="bg-white rounded-2xl shadow-xl px-8 py-12 sm:px-12 lg:px-8 flex flex-col">
            <div className="mb-12 space-y-4 flex-grow">
              <h3 className="text-2xl font-semibold text-[#0a1b96]">Selling</h3>
              <p className="mb-6">
                We focus on high-grade electronic materials and accessories for
                elevators, including modern buttons, displays, door mechanisms,
                and advanced screens such as TFT LCD and LED for seamless
                communication
              </p>
            </div>
            <img
              src="https://www.grace.edu/wp-content/uploads/2022/03/Marketing-Major-Professional-Sales-Degree-Concentration-1024x513.jpg"
              className="w-full h-40 object-cover "
              alt="illustration"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default OurServices;
